/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService
 */
import * as References from './PortalService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService#createPortal
 */
export const CREATE_PORTAL_MUTATION_FIELD_NAME = 'com_hubspot_academy_simulation_environment_rpc_PortalService_createPortal';
export const CREATE_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_PORTAL_MUTATION_FIELD_NAME,
  args: ['exerciseId', 'sourcePortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService#getPortalProvisioningStatus
 */
export const GET_PORTAL_PROVISIONING_STATUS_QUERY_FIELD_NAME = 'com_hubspot_academy_simulation_environment_rpc_PortalService_getPortalProvisioningStatus';
export const GET_PORTAL_PROVISIONING_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_PROVISIONING_STATUS_QUERY_FIELD_NAME,
  args: ['exerciseId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPortalProvisioningStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});